export const SCHOOL_YEAR_START_MONTH = 9;
